import React from 'react';

export interface StoreContextProps {
  get: <T>(key: string) => T | undefined
  set: <T>(key: string, value: T) => void
  remove: (key: string) => void
}

export interface StoreContextProviderProps {
  children: React.ReactNode
}

const initialStoreContext: StoreContextProps = {
  get: () => undefined,
  set: () => {},
  remove: () => {},
};

export const DefaultEmptyStoreContext = React.createContext(initialStoreContext);
